import { DataBean } from "../DataBean";

export class OfferEmployee extends DataBean{

    public async getOfferEmployeeCatalogRender(idAdquisitionItem:number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getOfferEmployeeCatalogRender_Number", [idAdquisitionItem]);
    }
}